import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    anchor: {
        color: theme.palette.primary.dark,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    link_container: {
        display: 'flex',
        alignItems: 'center'
    },
    start_icon_container:{
        color: theme.palette.primary.dark,
        marginRight: '4px',
    },
    end_icon_container:{
        color: theme.palette.primary.dark,
        marginLeft: '4px'
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
        cursor: 'not-allowed',
        '& $anchor': {
            color: theme.palette.text.disabled,
            textDecoration: 'none',
        },
        '& $start_icon_container, & $end_icon_container': {
            color: theme.palette.text.disabled,
        }
    }
}));

export {useStyles}